import * as React from 'react';
import useAuth from '@/auth/use-auth';

export default function Footer() {
  const { version, build_number } = useAuth();
  const year = (new Date()).getFullYear();

  return (
    <div className='footer'>
      <span className='copyright'>&copy; 2022-{year} ООО «Оператор Газпром ИД» SDK</span>&nbsp;<small className='version'>Public v{version} ({build_number})</small>
    </div>
  );
}
